
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14.631 14.631"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"send(1)"}},[_c('g',{attrs:{"data-name":"Group 898"}},[_c('g',{attrs:{"data-name":"Group 897"}},[_c('path',{attrs:{"data-name":"Path 7061","d":"M.271 5.498a.43.43 0 00-.028.787l5.045 2.449 8.735-8.736z","fill":"#fff"}})])]),_c('g',{attrs:{"data-name":"Group 900"}},[_c('g',{attrs:{"data-name":"Group 899"}},[_c('path',{attrs:{"data-name":"Path 7062","d":"M5.897 9.343l2.447 5.045a.43.43 0 00.387.243h.015a.431.431 0 00.384-.27L14.63.61z","fill":"#fff"}})])])])])
          )
        }
      }
    